import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useEffect, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { useNavigate } from "react-router-dom"
import pattern from "../images/pattern.png";

// const collections = [
//   {title: "Curly Wigs", image: 'https://images.unsplash.com/photo-1573617868130-7e757dbad187?q=80&w=1093&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'},
//   {title: "Straight Wigs", image: 'https://images.unsplash.com/photo-1519421692594-d7a3f3e3fe5f?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'},
//   {title: "Wavy Wigs", image: 'https://images.unsplash.com/photo-1663582816182-15cf69d87665?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'},
//   {title: "Pixie Cut Wigs", image: 'https://images.unsplash.com/photo-1663582816182-15cf69d87665?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
// ]

export default function Home() {
    const [pageLoading, setPageLoading] = useState(true);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [collections, setCollections] = useState([]);
    const { addToCart, checkItemInCart, removeItem } = useCart();
    const navigate = useNavigate();
    useEffect(() => {
        getData();
    }, [])
    async function getData() {
        const formData = new FormData();

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/fetch_popular_products.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                setFeaturedProd(response.data.data)
                setCollections(response.data.collections);
            } else {

            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
        }
    }

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            <Navbar />
            <section className="grid grid-cols-1 md:grid-cols-3">
                <div 
                style={{
                    backgroundImage: `url(${pattern})`,
                    backgroundColor: '#7d5af6',
                    backgroundBlendMode: 'soft-light', // or multiply, soft-light
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                }}
                // style={{ backgroundImage: "url(../images/pattern.png)", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} 
                className="col-span-1 md:col-span-2 text-white flex items-center px-10">
                    <div className="py-10 px-2 md:p-10 space-y-4">
                    <h2 className="text-4xl md:text-6xl font-bold">
                        Get amazing discounts off
                        <span className="block text-[#fc8c06]">New Arrivals</span>
                    </h2>
                    <p className="text-md text-gray-300">
                        Introducing our latest collection made for you
                    </p>
                    <button onClick={() => navigate("/shop-now")} className="border border-white text-white px-6 py-2 text-md md:text-lg">
                        START SHOPPING NOW →
                    </button>
                    </div>
                </div>

                <div className="h-[50vh] md:min-h-[70vh] bg-orange-200 col-span-1 flex items-center justify-center">
                    <img
                    src={front_model}
                    alt="model"
                    className="h-full object-cover"
                    />
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-4 py-14">
                <h3 className="text-center text-2xl font-semibold mb-8">
                    THIS WEEK'S HIGHLIGHT
                </h3>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                    {collections?.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => navigate('/shop-now')}
                        className={`
                        relative cursor-pointer overflow-hidden group h-[280px]
                        `}
                    >
                        {/* Image */}
                        <img
                        src={item.image}
                        alt={item.title}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-black/30" />

                        {/* Text */}
                        <div className="relative z-10 h-full flex flex-col justify-between p-6">
                        <h3 className="text-white text-2xl md:text-3xl font-semibold leading-tight">
                            {item.title}
                        </h3>

                        <div className="bg-black/50 text-white text-xs p-3 w-fit">
                            <p className="font-semibold">{item.title}</p>
                            <p className="uppercase text-[10px] mt-1">
                            Amazing prices
                            </p>
                            <p className="uppercase text-[10px]">
                            Check out this collection
                            </p>
                        </div>
                        </div>
                    </div>
                    ))}
                </div>
                <div className="flex justify-center md:justify-end">
                    <button onClick={() => navigate('/shop-now')} className="py-2 md:py-3 px-5 border rounded-sm my-3 border-2 text-md md:text-xl border-[#7d5af6] text-[#7d5af6]">Shop all Collections</button>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-4 py-14">
                <h3 className="text-center text-2xl font-semibold mb-10">
                    PRODUCT SPOTLIGHT
                </h3>

                <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
                    {featured_prod?.map((i, index) => (
                    <div key={index} onClick={() => navigate(`/shop-now/${i.id}/${i.name}`, {state: {product_id: i.id, name: i.name}})} className="text-sm cursor-pointer">
                        <div 
                        style={{ backgroundImage: `url(${i.image})` }}
                        className="bg-cover bg-center h-[15em] md:h-60 mb-3" />
                        <p className="font-medium">{i.name}</p>
                        <p className="text-gray-500">{i.starts_from}</p>
                        <div className="flex flex-row justify-between items-center mt-2">
                            <p className={`${i.in_stock > 1 ? 'text-[#00b47a]' : 'text-[#ff0000]'} text-sm italic`}>{i.in_stock} unit(s) left</p>
                            <div className="flex flex-col">
                                {/* <button onClick={() => i.in_stock > 0 ? addToCart(i.id, 'product', 1) : null} className="text-md underline">
                                + Add to Cart
                                </button> */}
                                {checkItemInCart(i.id) > 0 &&
                                    <a onClick={() => removeItem(i.id)} className="cursor-pointer text-sm text-gray-500 flex items-center gap-x-1"><LiaTimesSolid color="#585858" size={13} /> {checkItemInCart(i.id)} added</a>
                                }
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
                <div className="flex justify-center md:justify-end">
                    <button onClick={() => navigate('/shop-now')} className="py-2 md:py-3 px-5 border rounded-sm my-3 border-2 text-md md:text-xl border-[#7d5af6] text-[#7d5af6]">Shop all Products</button>
                </div>
            </section>
            <Footer />
        </div>
    )
}

